(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/regenerator', 'babel-runtime/helpers/slicedToArray', 'babel-runtime/helpers/asyncToGenerator', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/createClass', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', './AuthContext', './client', './token'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/helpers/slicedToArray'), require('babel-runtime/helpers/asyncToGenerator'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/createClass'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('./AuthContext'), require('./client'), require('./token'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.slicedToArray, global.asyncToGenerator, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.inherits, global.react, global.AuthContext, global.client, global.token);
    global.AuthFlowProvider = mod.exports;
  }
})(this, function (exports, _regenerator, _slicedToArray2, _asyncToGenerator2, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _inherits2, _react, _AuthContext, _client, _token) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _createClass3 = _interopRequireDefault(_createClass2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _AuthContext2 = _interopRequireDefault(_AuthContext);

  var _client2 = _interopRequireDefault(_client);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ANONYMOUS_ROLE = 'ANONYMOUS';

  var CODE_RE = /[?&]code=[^&]+/;
  var STATE_RE = /[?&]state=[^&]+/;
  var ERROR_RE = /[?&]error=[^&]+/;

  var hasAuthRedirectParams = function hasAuthRedirectParams() {
    var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
    return (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) && STATE_RE.test(searchParams);
  };

  var AuthFlowProvider = function (_React$Component) {
    (0, _inherits3.default)(AuthFlowProvider, _React$Component);

    function AuthFlowProvider(props) {
      (0, _classCallCheck3.default)(this, AuthFlowProvider);

      var _this = (0, _possibleConstructorReturn3.default)(this, (AuthFlowProvider.__proto__ || Object.getPrototypeOf(AuthFlowProvider)).call(this, props));

      _this.state = {
        authReady: false,
        isLoggedIn: false,
        me: null,
        error: null,
        isRedirecting: false
      };

      _this.login = _this.login.bind(_this);
      _this.handleRedirectCallback = _this.handleRedirectCallback.bind(_this);
      return _this;
    }

    (0, _createClass3.default)(AuthFlowProvider, [{
      key: 'login',
      value: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
          var fetchCurrentUser, authReady, token, _ref2, _ref3, user, error, role, isLoggedIn;

          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  fetchCurrentUser = this.props.fetchCurrentUser;
                  authReady = this.state.authReady;
                  _context.prev = 2;
                  _context.next = 5;
                  return _client2.default.checkSession();

                case 5:
                  _context.next = 7;
                  return (0, _token.getToken)();

                case 7:
                  token = _context.sent;

                  if (!(token != null)) {
                    _context.next = 22;
                    break;
                  }

                  _context.next = 11;
                  return fetchCurrentUser(token);

                case 11:
                  _ref2 = _context.sent;
                  _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
                  user = _ref3[0];
                  error = _ref3[1];

                  if (!error) {
                    _context.next = 17;
                    break;
                  }

                  throw new Error('Error fetching user');

                case 17:
                  role = user.role;
                  isLoggedIn = !(role && role === ANONYMOUS_ROLE);

                  this.setState({ authReady: true, isLoggedIn: isLoggedIn, me: user });
                  _context.next = 23;
                  break;

                case 22:
                  this.setState({ authReady: true, isLoggedIn: false });

                case 23:
                  _context.next = 28;
                  break;

                case 25:
                  _context.prev = 25;
                  _context.t0 = _context['catch'](2);

                  this.setState({ authReady: authReady, isLoggedIn: false, me: null, error: _context.t0 });

                case 28:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this, [[2, 25]]);
        }));

        function login() {
          return _ref.apply(this, arguments);
        }

        return login;
      }()
    }, {
      key: 'handleRedirectCallback',
      value: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
          var authReady, _ref5, appState;

          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  authReady = this.state.authReady;
                  _context2.prev = 1;

                  this.setState({ isRedirecting: true });
                  _context2.next = 5;
                  return _client2.default.handleRedirectCallback();

                case 5:
                  _ref5 = _context2.sent;
                  appState = _ref5.appState;

                  if (appState && appState.returnTo) {
                    window.location = appState.returnTo;
                  }
                  _context2.next = 14;
                  break;

                case 10:
                  _context2.prev = 10;
                  _context2.t0 = _context2['catch'](1);

                  console.error(_context2.t0);
                  this.setState({ authReady: authReady, isLoggedIn: false, me: null, error: _context2.t0 });

                case 14:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[1, 10]]);
        }));

        function handleRedirectCallback() {
          return _ref4.apply(this, arguments);
        }

        return handleRedirectCallback;
      }()
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var skipRedirectCallbackRegex = this.props.skipRedirectCallbackRegex;

        // avoid running the Auth0 redirect callback on certain routes
        var skipRedirectCallback = skipRedirectCallbackRegex != null && skipRedirectCallbackRegex.test(window.location.pathname);
        if (hasAuthRedirectParams() && !skipRedirectCallback) {
          this.handleRedirectCallback();
        } else {
          this.login();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var renderRedirecting = this.props.renderRedirecting;
        var _state = this.state,
            authReady = _state.authReady,
            isLoggedIn = _state.isLoggedIn,
            me = _state.me,
            error = _state.error,
            isRedirecting = _state.isRedirecting;

        if (isRedirecting) return renderRedirecting();
        return _react2.default.createElement(
          _AuthContext2.default.Provider,
          { value: { authReady: authReady, isLoggedIn: isLoggedIn, me: me, error: error } },
          this.props.children
        );
      }
    }]);
    return AuthFlowProvider;
  }(_react2.default.Component);

  exports.default = AuthFlowProvider;
});